import React from 'react';
import Sparkline from './Sparkline';
import InfoHint from './InfoHint';

interface Props {
  label: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
  delta?: number | null;         // signed % change; sign drives color/arrow
  deltaGoodWhenUp?: boolean;     // false for "bad" metrics (cost, hallucination)
  spark?: number[];
  sparkColor?: string;
  hint?: string;
  help?: string;                 // plain-English explanation shown via an info tooltip
  onClick?: () => void;
}

const StatCard: React.FC<Props> = ({
  label, value, icon, delta, deltaGoodWhenUp = true, spark, sparkColor, hint, help, onClick,
}) => {
  const showDelta = delta !== null && delta !== undefined && !Number.isNaN(delta);
  const up = (delta || 0) >= 0;
  const good = showDelta ? (up === deltaGoodWhenUp) : true;
  const deltaColor = !showDelta || delta === 0 ? 'var(--mx-text-subtle)'
    : good ? 'var(--mx-success)' : 'var(--mx-danger)';

  return (
    <div className="mx-card mx-card-pad" onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : undefined}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span className="mx-muted" style={{ fontSize: 13, fontWeight: 500, display: 'inline-flex', alignItems: 'center', gap: 5 }}>
          {label}{help && <InfoHint text={help} />}</span>
        {icon && <span style={{ color: 'var(--mx-text-subtle)' }}>{icon}</span>}
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginTop: 10 }}>
        <div>
          <div className="mx-num" style={{ fontSize: 28, fontWeight: 700, lineHeight: 1.1 }}>{value}</div>
          {showDelta && (
            <div style={{ fontSize: 12, fontWeight: 600, color: deltaColor, marginTop: 4 }}>
              {up ? '▲' : '▼'} {Math.abs(delta as number).toFixed(1)}%
            </div>
          )}
          {!showDelta && hint && (
            <div className="mx-subtle" style={{ fontSize: 12, marginTop: 4 }}>{hint}</div>
          )}
        </div>
        {spark && spark.length > 1 && (
          <Sparkline data={spark} color={sparkColor || 'var(--mx-accent)'} />
        )}
      </div>
    </div>
  );
};

export default StatCard;
